import './B2BTable.css';

import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableContainer, TableHead, TableRow, Paper, TableCell as MuiTableCell, Pagination, CircularProgress, PaginationItem } from '@mui/material';
import { generateClassName } from './helpers';
import B2BButtonGroup from './B2BButtonGroup';
import useB2BTranslation from './hooks/useB2BTranslation';

const B2BTable = ({ headers, rows, pagesCount, currentPage,
    onPageChange, onRowClick,
    rowLoading = null,
    pageLoading = null,
    tableLoading = null,
    className = null,
    stickyHeader = false,
    buttons = null }) => {

    const { t } = useB2BTranslation('b2b-common');
    const [loadingRowId, setLoadingRowId] = useState(null);
    const [pageNumberLoading, setPageNumberLoading] = useState(null);

    const handleRowClick = async (row) => {
        if (!loadingRowId && onRowClick) {
            onRowClick(row);
        }
    };

    useEffect(() => {
        setLoadingRowId(rowLoading);
    }, [rowLoading]);

    useEffect(() => {
        setPageNumberLoading(pageLoading);
    }, [pageLoading]);

    return (
        <div className={generateClassName("b2b-table", "-container", className)}>
            {tableLoading && (
                <div className={generateClassName("b2b-table", "-loading", className)}>
                    <CircularProgress size={25} />
                </div>
            )}
            {!tableLoading && (
                <React.Fragment>
                    <div className={generateClassName("b2b-table", "-component", className)}>
                        {buttons && buttons.length > 0 && (
                            <B2BButtonGroup className="b2b-table-buttons" buttonConfigs={buttons} />
                        )}
                        <TableContainer component={Paper} className={generateClassName("b2b-table", "-table-container", className)}>
                            <Table stickyHeader={stickyHeader ? true : false} size="small" aria-label="a dense table" className={generateClassName("b2b-table", "", className)}>
                                <TableHead className={generateClassName("b2b-table", "-head", className)}>
                                    <TableRow>
                                        {headers.map((header, index) => (
                                            <MuiTableCell key={index} align={header.align || 'left'} className={`${generateClassName("b2b-table", "-header-cell", className)} column-${index + 1}`}>
                                                {header.label}
                                            </MuiTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody className={generateClassName("b2b-table", "-body", className)}>
                                    {rows && rows.length > 0 ? (
                                        rows.map((row) => (
                                            <React.Fragment key={row.id}>
                                                {loadingRowId === row.id ? (
                                                    <TableRow key={row.id} className={generateClassName("b2b-table", "-body-row-loading", className)}>
                                                        <MuiTableCell align="center" className={generateClassName("b2b-table", "-body-cell", className)} colSpan={headers.length}>
                                                            <CircularProgress size={15} />
                                                        </MuiTableCell>
                                                    </TableRow>
                                                ) : (
                                                    <TableRow key={row.id} onClick={() => handleRowClick(row)} className={generateClassName("b2b-table", "-body-row", className)}>
                                                        {row.cells.map((cell, index) => (
                                                            <MuiTableCell key={index} align={cell.align || 'left'} className={generateClassName("b2b-table", "-body-cell", className)}>
                                                                {cell.content}
                                                            </MuiTableCell>
                                                        ))}
                                                    </TableRow>
                                                )}
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <MuiTableCell align="center" colSpan={headers.length} className={generateClassName("b2b-table", "-nodata-body-cell", className)}>
                                                {t('No data to show!')}
                                            </MuiTableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer >
                        {pagesCount > 1 && (
                            <Pagination
                                count={pagesCount}
                                page={currentPage}
                                onChange={onPageChange}
                                color="primary"
                                className={generateClassName("b2b-table", "-pagination", className)}
                                renderItem={(item) => {
                                    const toBeDisabled = (item.type === 'previous' && currentPage === 1) || (item.type === 'next' && currentPage === pagesCount);
                                    const modifiedItem = {
                                        ...item,
                                        className: generateClassName("b2b-table", "-pagination-item", className),
                                        disabled: toBeDisabled,
                                        page: pageNumberLoading === item.page ? '...' : item.page,
                                    };
                                    return <PaginationItem {...modifiedItem} />;
                                }}
                            />
                        )}
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};

export default B2BTable;